<div style="display: flex;flex-direction: row;width: 100%;height: 100%;">
    <div class="dialog-title-container">
      <div class="dialog-title-text">{{"user_profile.lbl_user_profile" | translate}}</div>
    </div>
    <div class="tab-container app-dark-bg">
            <div class="tabs">
                <a *ngIf="getViewMode() == 2" [class.active]="getViewMode() == 2" (click)="changeViewMode(2)">{{"user_profile.lbl_user_profile" | translate}}</a>
            </div>
            <div class="tab-forms app-light-bg">                
                <app-user-profile-edit *ngIf="getViewMode() === 2" [data]="data"></app-user-profile-edit>
            </div>            
    </div>
</div>